import * as d3 from "d3";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import "./PerformanceBar.css";
import "./TimelineBlock.css";
import { XAxis } from "./XAxis";
import { Tooltip } from "antd";

function TimelineBlock({
  endDate,
  active,
  activeDateMapping,
  hoursWithData,
  yellowHours,
  redHours,
  greenHours,
}) {
  const height = 3;
  const screenWidth = 400;
  const [width, setWidth] = useState(screenWidth / (12 + 5) / 2);
  const [multiplier, setMultiplier] = useState(1);
  const [interval, setInterval] = useState(1);

  const dates = useMemo(() => {
    if (endDate) {
      let endDate_ = moment(endDate)
        .endOf("day")
        .add(1, "millisecond")
        .toDate()
        .toISOString();
      if (active === "day") setInterval(1);
      if (active === "week") setInterval(6);
      else if (active === "month") setInterval(24);
      const dates = [];
      for (let i = 0; i < 24; i++) {
        endDate_ = moment(endDate_)
          .subtract(interval, "hours")
          .toDate()
          .toISOString();
        dates.push(endDate_);
      }
      return dates;
    }
    return [];
  }, [active, endDate, interval]);

  const xAxis = useMemo(() => {
    return d3
      .scaleTime()
      .domain([moment(dates[dates.length - 1]).utc(), moment(dates[0]).utc()])
      .range([10, screenWidth - width * 2]);
  }, [dates, width]);

  const handleClick = (date) => {
    activeDateMapping(active, date, false);
  };
  const getColor = (x) => {
    if (hoursWithData.has(x.substring(0, 13))) {
      if (redHours[x.substring(0, 13)]) {
        return "#FF7373";
      } else if (yellowHours[x.substring(0, 13)]) {
        return "#fff1a9";
      } else if (greenHours[x.substring(0, 13)]) {
        return "#92bf8b";
      } else {
        return "#8a8a8a";
      }
    }
    return "#e3e7e5";
  };

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (window.innerWidth >= 768) {
        setMultiplier(2);
      } else {
        setMultiplier(1);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {xAxis && (
        <div className="TimelineBlock" style={{ marginTop: "-20px" }}>
          <svg
            className="TimelineBlock_bar"
            width={screenWidth}
            height={height * 2/multiplier}
            viewBox={`0 0 ${screenWidth * multiplier} ${height}`}
          >
            {dates.length > 0 &&
              dates.map((x) => (
                <Tooltip
                  title={moment(x).format("hh A")}
                  key={`tooltip-rect-${x}`}
                >
                  <rect
                    x={xAxis(moment(x))}
                    y={0}
                    height={height * 1.5/multiplier}
                    width={width}
                    key={`rect-${x}`}
                    fill={getColor(x)}
                    stroke={"#dadada"}
                    strokeWidth={"1px"}
                    onClick={() => handleClick(x)}
                    className={
                      hoursWithData.has(x.substring(0, 13)) &&
                      moment(x).add(1, "hour").toDate() > new Date()
                        ? "TimelineBlock__hourButton TimelineBlock__realtime"
                        : "TimelineBlock__hourButton"
                    }
                  ></rect>
                </Tooltip>
              ))}
          </svg>
        </div>
      )}
    </>
  );
}

export default observer(TimelineBlock);
